import _ from 'underscore';

export const Campaign = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Campaign',
    },
    Name: {
      'bulk-upload-header': 'Campaign',
    },
    CampaignSubType: {
      'bulk-upload-header': 'Sub Type',
    },
    TrackingUrlTemplate: {
      'bulk-upload-header': 'Tracking Template',
      bulkDeleteValueIfEmpty: true,
    },
    UrlCustomParameters: {
      'bulk-upload-header': 'Custom Parameter',
      'bulk-upload-mapper': function (value) {
        return _.map(value, p => `{_${p.Key}}=${p.Value}`).join('; ');
      },
      bulkDeleteValueIfEmpty: true,
    },
    FinalUrlSuffix: {
      'bulk-upload-header': 'Final Url Suffix',
      bulkDeleteValueIfEmpty: true,
    },
    BudgetId: {
      'bulk-upload-header': 'Budget Id',
    },
    BudgetName: {
      'bulk-upload-header': 'Budget Name',
    },
    TimeZone: {
      'bulk-upload-header': 'Time Zone',
    },
    AdScheduleUseSearcherTimeZone: {
      'bulk-upload-header': 'Ad Schedule Use Searcher Time Zone',
    },
    Languages: {
      filterable: true,
      'bulk-upload-header': 'Language',
      'bulk-upload-mapper': function (value) {
        return value.join(';');
      },
    },
    NativeBidAdjustment: {
      'bulk-upload-header': 'Bid Adjustment',
    },
    MultimediaAdBidAdjustment: {
      'bulk-upload-header': 'Multi Media Ad Bid Adjustment',
    },
    AutomatedCallToActionOptOut: {
      'bulk-upload-header': 'Automated Call To Action Opt Out',
      type: 'boolean',
    },
    CampaignType: {
      'bulk-upload-header': 'Campaign Type',
      'bulk-upload-mapper': function (value) {
        if (value === 'DynamicSearchAds') {
          return 'Dynamic Search';
        }
        return value;
      },
    },
    CampaignGoal: {
      'bulk-upload-header': 'Campaign Goal',
      'bulk-upload-mapper': function (value) {
        const mapping = {
          MoreCalls: 1,
          MoreVisitsToPhysicalLocation: 2,
          MoreWebsiteActions: 3,
          MoreBrandAwareness: 4,
          MoreSales: 5,
        };

        return mapping[value];
      },
    },
    DomainName: {
      'bulk-upload-header': 'Website',
    },
    LanguageCode: {
      'bulk-upload-header': 'Domain Language',
    },
    Source: {
      'bulk-upload-header': 'Source',
    },
    DynamicDescriptionEnabled: {
      'bulk-upload-header': 'Dynamic Description Enabled',
    },
    AutoGeneratedAssetsEnabled: {
      'bulk-upload-header': 'RSA Auto Generated Assets Enabled',
    },
    IsBroadMatchOnlyCampaign: {
      'bulk-upload-header': 'Is Broad Match Only Campaign',
    },
    TargetSetting: {
      'bulk-upload-header': 'Target Setting',
    },
    DisclaimerAdsEnabled: {
      'bulk-upload-header': 'Disclaimer Ads Enabled',
    },
    BidStrategyId: {
      'bulk-upload-header': 'Bid Strategy Id',
    },
    BidStrategyName: {
      'bulk-upload-header': 'Bid Strategy Name',
    },
    CashbackMonthlyBudget: {
      'bulk-upload-header': 'Cashback Monthly Budget',
    },
    CashbackPercent: {
      'bulk-upload-header': 'Cashback Percent',
    },
    CashbackScope: {
      'bulk-upload-header': 'Cashback Scope',
    },
    PersonalizedOffersEnabled: {
      'bulk-upload-header': 'Personalized Offers Enabled',
    },
    CouponsEnabled: {
      'bulk-upload-header': 'Personalized Coupons Enabled',
    },
    VerifiedTrackingData: {
      'bulk-upload-header': 'Verified Tracking Settings',
      'bulk-upload-mapper': function (value) {
        if (_.isEmpty(value) || (_.isString(value) && value.length === 0)) {
          // '': two inouts are empty
          // 'error': Only one of id is '', invalid
          return 'delete_value';
        }
        return value;
      },
    },
    FeedLabel: {
      'bulk-upload-header': 'FeedLabel',
    },
    SalesCountry: {
      'bulk-upload-header': 'Country Code',
    },
    ShoppableAdsEnabled: {
      'bulk-upload-header': 'Shoppable Ads Enabled',
      'bulk-upload-mapper': function (value) {
        return value ? 'true' : 'false';
      },
    },
    BrandOnly: {
      'bulk-upload-header': 'Brand Only',
      'bulk-upload-mapper': function (value) {
        return value ? 'true' : 'false';
      },
    },
    LocalInventoryAdsEnabled: {
      'bulk-upload-header': 'Local Inventory Ads Enabled',
      'bulk-upload-mapper': function (value) {
        return value ? 'true' : 'false';
      },
    },
    Priority: {
      'bulk-upload-mapper': function (value) {
        const mapping = {
          Low: 0,
          Medium: 1,
          High: 2,
          Highest: 3,
        };

        return mapping[value];
      },
    },
    ProviderId: {
      'bulk-upload-header': 'Store Id',
    },
    IsLeadGenCampaign: {
      'bulk-upload-header': 'Is Lead Gen Campaign',
    },
    AutoTargetingEnabled: {
      'bulk-upload-header': 'Predictive Targeting Enabled',
      type: 'boolean',
    },
    AutoGeneratedImageOptOut: {
      'bulk-upload-header': 'Auto Generated Image Assets Opt Out',
      type: 'boolean',
    },
    AutoGeneratedTextOptOut: {
      'bulk-upload-header': 'Auto Generated Text Assets Opt Out',
      type: 'boolean',
    },
    FinalUrlExpansionOptOut: {
      'bulk-upload-header': 'Url Expansion Opt Out',
      type: 'boolean',
    },
    CostPerSaleOptOut: {
      'bulk-upload-header': 'Cost Per Sale Opt Out',
      type: 'boolean',
    },
    AppStore: {
      'bulk-upload-header': 'App Store',
      type: 'string',
    },
    AppId: {
      'bulk-upload-header': 'App Id',
      type: 'string',
    },
    PageFeedIds: {
      type: 'string',
      'bulk-upload-header': 'Page Feed Ids',
      'bulk-upload-mapper': function (value) {
        if (_.isArray(value)) {
          return _.isEmpty(value) ? 'delete_value' : value.join(';');
        }
        return '';
      },
    },
    DisplayUrlMode: {
      type: 'string',
      'bulk-upload-header': 'Vanity Pharma Display URL Mode',
    },
    WebsiteDescription: {
      type: 'string',
      'bulk-upload-header': 'Vanity Pharma Website Description',
    },
    IsDealCampaign: {
      'bulk-upload-header': 'Is Deal Campaign',
      type: 'boolean',
    },
    CallToActionOptOut: {
      'bulk-upload-header': 'Call To Action Opt Out',
      type: 'boolean',
    },
    StartDate: {
      'bulk-upload-header': 'Start Date',
    },
    EndDate: {
      'bulk-upload-header': 'End Date',
    },
    UseCampaignLevelDates: {
      'bulk-upload-header': 'Use Campaign Level Dates',
    },
  },
};
